<!--
일괄기능-세금계산서
------------------------------------

-->
<template>
<div class="">

    <button
        class="uk-button uk-button-gray mr-1rem"
        type="button"
        :disabled="disabled"
        @click="collectiveView"
    >
        <i class="material-icons uk-text-middle">view_module</i>
        <span class="uk-text-middle">계산서 모아보기</span>
    </button>

    <button
        class="uk-button uk-button-gray mr-1rem"
        type="button"
        :disabled="disabled"
        @click="totalPriceView"
    >
        <i class="material-icons uk-text-middle">insert_chart_outlined</i>
        <span class="uk-text-middle">총 금액</span>
    </button>

    <button
        class="uk-button uk-button-gray mr-1rem"
        type="button"
        :disabled="disabled"
        @click="hometaxExcelLarge"
    >
        <i class="material-icons uk-text-middle">download</i>
        <span class="uk-text-middle">홈택스양식(100건초과) 다운</span>
    </button>

    <button
        class="uk-button uk-button-gray mr-1rem"
        type="button"
        :disabled="disabled"
        @click="hometaxExcelSmall"
    >
        <i class="material-icons uk-text-middle">download</i>
        <span class="uk-text-middle">홈택스양식(100건이하) 다운</span>
    </button>

    <!-- 처리중화면 blockui -->
    <overlay-loading ref="down-overlay">
        <div slot="dialog">
            <loading-icon></loading-icon>
            다운로드중.. 잠시만 기다리세요.
        </div>
    </overlay-loading>
    
</div>
    
</template>

<script>
    import searchedSelectable from "../../searched-selectable.vue";
    import LoadingIcon from "../../../common/loading-icon.vue";
    import OverlayLoading from "../../../common/overlay-loading.vue";


    export default {
        mixins: [
            searchedSelectable,
        ],
        components: {
            LoadingIcon,
            OverlayLoading,
        },

        props: {
            /**
             * 일괄기능 공유data (상세정의는 컨트롤러 참고)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            
            return {
            };
        },
        computed: {
            // 작업 버튼 비활성화 여부
            disabled() {
                // 선택된 아이템없으면 비활성화
                return this.batch.checked_item_count === 0;
            },

        },
        methods: {
            /**
             * 선택 모아보기
             */
            collectiveView() {
                const url = '/tax-invoices/collective-view?';

                const form = document.createElement("form");
                form.method = 'post';
                form.action = url;
                form.target = 'collective-view';


                // 파라메터 추가
                const data = new FormData();
                data.set("_token", this.csrfToken);
                _.forEach(this.batch.checked_items, item => {
                    data.append('invoice_ids[]', item.id);
                });

                this.openWindow(form, data);

            },
            /**
             * 선택 총 금액확인
             */
            totalPriceView() {
                let url = '/tax-invoices/total-price-view?';

                const form = document.createElement("form");
                form.method = 'post';
                form.action = url;
                form.target = 'total-price-view';


                // 파라메터 추가
                const data = new FormData();
                data.set("_token", this.csrfToken);
                _.forEach(this.batch.checked_items, item => {
                    data.append('invoice_ids[]', item.id);
                });

                this.openWindow(form, data);
            },
            /**
             * 홈택스 양식다운 (100건 초과)
             */
            hometaxExcelLarge() {
                 this.hometaxExcelDown('1');
            },
            /**
             * 홈택스 양식다운 (100건 이하)
             */
            hometaxExcelSmall() {
                 this.hometaxExcelDown('2');
            },

            /**
             * 특정 url 다운로드처리
             */
            hometaxExcelDown(format) {

                const url = new URL('/tax-invoices/hometax-excel', location.origin);
                const searchParams = url.searchParams;
                searchParams.set("__accept", "excel");
                searchParams.set("format", format);

                // post 파라메터 작성
                let post_params = new URLSearchParams();
                post_params.set("_token", this.csrfToken);
                _.each(this.batch.checked_items, (item) => {
                    post_params.append("invoice_ids[]", item.id);
                });


                // fetch 옵션
                let fetch_options = {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    },
                    body: post_params,
                };

                // 다운처리
                this.download(url, fetch_options, [
                    this.guardNoSelected,
                ]);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>